import React, { Component } from "react";
import axios from 'axios';
import {
  Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Dropdown,
  MenuItem, Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";

import {
  ROOT_URL, ROOT_API_URL, isDAICHEONG, isHMM, isGGI, isSV, isVAK,
} from '../../actions/root_url';

const addShippingAddress = (data, receivingCustomer, success) => {
  axios({
    method: 'PUT',
    data,
    url: `${ROOT_URL}v1/customer/${receivingCustomer}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success();
    }, err => {
      const data = err.data;
      alert(JSON.stringify(data));
    })
}

const dataValid = (data) => {
  if (isDAICHEONG) {
    if (!data.AddressName) {
      return;
    }
    return true;
  }
  if (isHMM) {
    if (!data.AddressName || !data.Telephone) {
      return;
    }
  } else {
    if (!data.AddressName || !data.Street || !data.City || !data.State || !data.Zip) {
      return;
    }
    if (!isSV && !data.Telephone) {
      return;
    }
  }
  return true;
}

const fetchCustomerDetails = (receivingCustomer, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}/v1/customer/${receivingCustomer}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res);
    }, err => {

    })
}

class ShippingAddressEditmodal extends Component {
  constructor() {
    super();
    this.state = {
      buttonDisabled: false,
      isEdit: false,
    };
  }

  componentDidMount() {
    if (isVAK) {
      this.setState({
        isEdit: this.props.isEdit,
      });
    }
    fetchCustomerDetails(this.props.receivingCustomer, this.handleFetchCustomerDetailsSuccess)
  }

  handleInputFieldChange = ({ name, value }) =>
    this.setState({ [name]: value });


  handleFetchCustomerDetailsSuccess = ({ data }) => {
    if (this.state.isEdit) {
      if (data.Shipping && data.Shipping.length > 0) {
        const shippingIndex = data.Shipping.findIndex(item => item.CustomerDetail_id === this.props.deliverCustomerDetail);
        if (shippingIndex !== -1) {
          const shipping = data.Shipping[shippingIndex];
          this.setState({
            ...shipping,
            customerDetails: data,
          });
        }
      }
    } else {
      this.setState({
        IsDefault: "true",
        AddressName: "",
        Telephone: "",
        Street: "",
        City: "",
        State: "",
        Zip: "",
        Email: "",
        Cellphone: "",
        customerDetails: data,
        AddressName1: "",
      })
    }
  }

  handleSubmit = () => {

    if (!dataValid(this.state)) {
      alert('Missing required fields')
      return;
    }

    this.setState({
      buttonDisabled: true,
    })
    const customerDetails = {
      ...this.state.customerDetails
    }

    let data = {
      ...this.state,
    };
    if(isGGI) {
      data.IsDefault = false;
    }

    delete data.customerDetails

    // customerDetails.Shipping = [data];
    if (this.state.isEdit) {
      const shippingIndex = customerDetails.Shipping.findIndex(shipping => shipping.CustomerDetail_id === this.props.deliverCustomerDetail);
      if (shippingIndex !== -1) {
        customerDetails.Shipping[shippingIndex] = data;
      }
    } else {
      customerDetails.Shipping.push(data);
    }

    addShippingAddress(customerDetails, this.props.receivingCustomer, () => {
      this.props.reFetchSalesCustomers();
      this.setState({
        buttonDisabled: false,
      })
    })
  };

  render() {
    const {
      AddressName, Telephone, Street, City, State, Zip, Cellphone, Email,
      AddressName1
    } = this.state;
    return (
      <div>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="name" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="cell_phone" />{isSV && <Translate value="optional_in_parentheses" />}:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="AddressName"
              value={AddressName}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="Telephone"
              value={Telephone}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              {/* <Translate value="alt_phone" />: */}
              <Translate value="optional_phone" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="email" /> (<Translate value="optional" />):
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="Cellphone"
              value={Cellphone}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="Email"
              value={Email}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="street" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="city" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="Street"
              value={Street}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="City"
              value={City}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="state" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="zip" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="State"
              value={State}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="Zip"
              value={Zip}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        {
          isSV &&
          <Row>
            <Col sm={6}>
              <label>
                <Translate value="attn" />:
              </label>
            </Col>
            <Col sm={6}>
            </Col>
          </Row>
        }
        {
          isSV &&
          <Row>
            <Col sm={6}>
              <Input
                type="text"
                name="AddressName1"
                value={AddressName1}
                onChange={(e) => this.handleInputFieldChange(e.target)}
              />
            </Col>
            <Col sm={6}>
            </Col>
          </Row>
        }
        <Row className="centerStyle" style={{ marginTop: "0px" }}>
          <Button
            bsStyle="success"
            // disabled={this.state.buttonDisabled}
            onClick={(e) => {
              this.handleSubmit();
            }}
          // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
          >
            <Translate value="submit" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default ShippingAddressEditmodal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/shippingInfoEditModal.jsx